import { GRAVITY, JUMP_SPEED, STEP_UP } from "./body";

// the body's numbers live in body.ts; these names stay importable from here for the landmark tests
export { GRAVITY, JUMP_SPEED, STEP_UP };

/** Highest a spawn may be lifted onto a collider top (the nomen stone stands 0.33 m above the plaza). */
export const SPAWN_LIFT = 1;

/** Feet height at spawn: the server sends terrain height, so stand on a collider top just above it. */
export function spawnFeetY(spawnY: number, hitY: number | null): number {
  return hitY !== null && hitY > spawnY && hitY - spawnY <= SPAWN_LIFT ? hitY : spawnY;
}
